interface StageButtonParam {
    stageNo: number
    active?: boolean
    onActivate: () => void;
}

interface StageButtonRowParam {
    count: number
    active: boolean[]
    onActivate: (index : number) => void;
}

export function StageButton(param : StageButtonParam) {
  return (
      <span onClick={param.onActivate} className={"stage-button"+(param.active ? " active" : "")}>{param.stageNo}</span>
      );
}   

function getActive(active : boolean[], index : number) {
    try {
        return active[index];
    } catch {
        return true;
    }
}

export function StageButtonRow(param : StageButtonRowParam) {
    return (
        <div className='stage-button-container'>
        {
            new Array(param.count).fill(0).map((_n, index) => ( <StageButton onActivate={() => param.onActivate(index)} key={index} stageNo={index+1} active={getActive(param.active, index)} /> ) )
        }
        </div>
    )
}